// extracted by mini-css-extract-plugin
export default {"root":"TwoColPhoto_root__wnUjM","photoCol":"TwoColPhoto_photoCol__be4c9","textCol":"TwoColPhoto_textCol__4IQWy"};